/**
 * Compares two objects if they are equal
 *
 * @param {String} origin - object to compare for equality
 * @param {String} other - object to compare for equality
 * @param {Boolean} normalizeArray - sort arrays in order to compare their entities
 *      ignoring their appearance in an array
 *
 * @returns {Boolean} equality result
 */
export const isEqual = (origin, other, normalizeArray = false) => {
    const objectType = '[object Object]';
    const arrayType = '[object Array]';

    const originType = Object.prototype.toString.call(origin);
    const otherType = Object.prototype.toString.call(origin);

    // If a type and a value are the same then they are equal
    if (origin === other && originType === otherType) {
        return true;
    }

    // If they have different types they are not equal
    if (originType !== otherType) {
        return false;
    }

    // Check is they are either objects or arrays
    if ([objectType, arrayType].indexOf(originType) === -1) {
        return false;
    }

    const originLength = originType === arrayType ? origin.length : Object.keys(origin).length;
    const otherLength = otherType === arrayType ? other.length : Object.keys(other).length;

    // If they have different length they are not equal
    if (originLength !== otherLength) {
        return false;
    }

    if (originType === arrayType) {
        const originArray = !normalizeArray ? origin : origin.sort();
        const otherArray = !normalizeArray ? other : other.sort();

        for (let i = 0; i < originLength; i += 1) {
            if (!isEqual(originArray[i], otherArray[i])) {
                return false;
            }
        }
    } else {
        for (let key in origin) { // eslint-disable-line
            if (origin.hasOwnProperty(key) && other.hasOwnProperty(key) && !isEqual(origin[key], other[key])) { // eslint-disable-line
                return false;
            }
        }
    }

    return true;
};
